import { z } from 'zod/v4';

import { endpoint } from '../http/endpoint';
import {
    RapidElectronicsCredentialsDTORuntype,
    RapidElectronicsResponseBodyDTORuntype,
} from './rapidElectronicsBackendTypes';

export const rapidElectronicsEndpoints = {
    'GET /3rdparty/rapidelectronics/credentials': endpoint({
        description: 'Returns credentials for rapidelectronics integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: RapidElectronicsResponseBodyDTORuntype,
    }),
    'POST /3rdparty/rapidelectronics/credentials': endpoint({
        description: 'Uploads credentials for rapidelectronics integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: RapidElectronicsCredentialsDTORuntype,
        responseBody: RapidElectronicsResponseBodyDTORuntype,
        invalidates: ['GET /3rdparty/rapidelectronics/credentials'],
    }),
    'PATCH /3rdparty/rapidelectronics/credentials': endpoint({
        description: 'Updates credentials for rapidelectronics integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: RapidElectronicsCredentialsDTORuntype,
        responseBody: RapidElectronicsResponseBodyDTORuntype,
        invalidates: ['GET /3rdparty/rapidelectronics/credentials'],
    }),
    'DELETE /3rdparty/rapidelectronics/credentials': endpoint({
        description: 'Deletes existing credentials for rapidelectronics integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: z.object({ deleted: z.number() }),
        invalidates: ['GET /3rdparty/rapidelectronics/credentials'],
    }),
};
